import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple"> Omer Farooq </span>
            from <span className="purple"> Karachi, Pakistan.</span>
            <br />I am a junior Web Developer and CS student in SMIU
            Karachi.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Writting Tech Blogs
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ marginBlockEnd: 0, color: "rgb(155 126 172)" }}>
            "never learn a code practice it!"{" "}
          </p>
          <footer className="blockquote-footer">Omer Farooq</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
